export default {"src":"/_next/static/media/logout.28307a8b.svg","height":512,"width":513};